export default "__VITE_ASSET__BIrdwXEi__"